export const DEFAULT_BONUS_ELIGIBLE_SHIFT_SHOPPING_CONFIG = {
  enabled: false,
  bonusAmountInDollars: 0,
  requiredShiftCount: 1,
  startDate: "",
  deadlineDate: "",
  minimumPostedHours: 72,
};
